import { notify, useModal } from '@billy/design-system'
import { useMutation, useQueryClient } from 'react-query'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { setAccountArchivedStatus } from '../query-api'

interface UseHideAccountProps {
  accountId: string
  modalId: string
}

export const useHideAccount = ({ accountId, modalId }: UseHideAccountProps) => {
  const { close } = useModal(modalId)
  const queryClient = useQueryClient()

  const {
    mutate: hideAccount,
    isLoading: isProcessing,
    ...rest
  } = useMutation(() => setAccountArchivedStatus({ accountId, isArchived: true }), {
    onSuccess: async () => {
      // `refetchInactive: true` is needed here because to force react-query to refetch archived accounts.
      await queryClient.invalidateQueries(QueryKeys.Accounts, { refetchInactive: true })
      await queryClient.invalidateQueries(QueryKeys.UserOrganization)
      close()
    },
    onError: (error: APIError) => {
      notify({ id: NotificationKeys.AccountArchive, message: error?.body?.errorMessage, variant: 'error' })
    },
  })

  return { hideAccount, isProcessing, ...rest }
}
